let CT;
window.ControlTemplate = CT = { "Description": "Html-шаблоны для динамических контролов" };

CT.toolBar = {};
CT.sideBar = {};
CT.form = {};
CT.dialog = {};

/**
* Шаблон кнопки панели инструментов
*
* @param {string} 1 name
* @param {string} 2title
* @param {string} 3 onclick action
* @param {string} 4 icon
* @return buttonTemplate
*/
CT.toolBar.button =
  `<div class="{4}" name="{0}" title="{5}" onclick="{2}">
     <p class="{3}"></p>
     <span class="toolbar-item__title">{1}</span>
   </div>`;
// Если иконка находится в атласе svg
CT.toolBar.buttonSvg =
  `<div class="{4}" name="{0}" title="{5}" onclick="{2}">
     <svg class="toolbar-item__icon">
       <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#{3}"/>
     </svg>
     <span class="toolbar-item__title">{1}</span>
   </div>`;
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

// language=HTML
/**
* Шаблон Группы панели инструментов
*
* @param {string} 0 name
* @param {string} 1 title
* @param {string} 2 icon
* @return buttonTemplate
*/
CT.toolBar.group =
  `<div class="toolbar_group" name="{0}">
     <div class="toolbar_group_header">
       <p class="{2}"></p>
       <span class="toolbar-item__title">{1}</span>
       <svg class="svg-component toolbar-item__arrow">
         <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#downMenu"/>
       </svg>
     </div>
   </div>`;
CT.toolBar.groupSvg =
  `<div class="toolbar_group" name="{0}">
     <div class="toolbar_group_header">
       <svg class="toolbar-item__icon">
         <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#{2}"/>
       </svg>
       <span class="toolbar-item__title">{1}</span>
       <svg class="svg-component toolbar-item__arrow">
         <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#downMenu"/>
       </svg>
     </div>
   </div>`;
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Панелька для свернутой группы кнопок
*
* @param {string} 0 index
* @param {string} 1 size
*/
CT.toolBar.groupCollapsed = '<div id="addedDiv" class="addedHiddenDiv" style="left: {0}px"></div>';
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Закладка боковой панели
*
* @param {string} 0 name
* @param {string} 1 text
* @param {string} 2 icon
* @param {string} 3 cssClass
*/
CT.sideBar.tab = '<div name="{0}" title="{4}" class="{3} compact inline_tab" id="ViewList_{0}"> \
                    <div> \
                      <p class="{2}"></p> \
                      <span>{1}</span> \
                      <sup></sup> \
                    </div> \
                  </div>';
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Кнопка действия поиска в шапке сайта.
*
* @param {string} 0 name
* @param {string} 1 text
* @param {string} 2 icon
* @param {string} 3 tooltip
*/
CT.sideBar.search = '<div name="{0}" class="explorer-search-panel__item" title="{3}"> \
                       <div class="action-button"> \
                         <svg class="svg-component action-button__icon"> \
                           <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#{2}"></use> \
                        </svg> \
                        <span class="action-button__caption">{1}</span> \
                       </div> \
                    </div>';
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Закладка(контейнер на карточке)
*
* @param {string} 0 name
*/

CT.form.tab = '<div id="CardForm_Tab_{0}" class="CardForm_Tab" style="display: none;"> \
              </div>';
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


/**
* Разметка новой закладки
*
* @param {string} 0 title
* @param {string} 1 helpText
* @param {string} 2 manualLink
*/

CT.form.tabHelp = '<h1>{0}</h1> \
                   <br/> \
                   <p>{1}</p> \
                   <a href="#manual">{2}</a> \
                  ';
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

CT.dialog.selectedItemsArea = '<div id="SelectedRecords" class="select-records-into" {extra_attributes}> \
                                <div class="area-label">{label}:</div> \
                                  <div id="selectedRecordsScrollArea" class="{area_class}"> \
                                    <table cellspacing="0" id="selectedRecordsTable"> \
                                    <thead> \
                                      <tr> \
                                        <th class="selectedRecordsHeader emptyHeader {display_delete}"></th> \
                                        <th class="selectedRecordsHeader">{name}</th> \
                                        <th class="selectedRecordsHeader {display_options}" {option_extra_attributes}>{option_name}</th>\
                                      </tr> \
                                      </thead> \
                                      {data} \
                                      </table> \
                                  </div> \
                                </div>';


CT.dialog.selectedItem = '<tr id="{id}" field="{field}" class="selected-records-item"> \
                            <td class="{display_delete}"> \
                              <svg class="selected-records-item__delete removeFromSelect" title="{delete_title}"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#delete-16"></use></svg> \
                            </td> \
                            <td class="{items_mode}"> \
                              <div class="{hint_class}" id="{id}_container" {hint_attr}> \
                                <a href="{url}" title="{name}" {extra_attributes}>{name}</a> \
                              </div> \
                            </td> \
                            <td class="{display_options}"> \
                              {option} \
                            </td> \
                          </tr>';

CT.dialog.availableItemsArea = '<div class="leftarea select-records-from {is_readonly}"> \
                                 <div class="area-label">{label}:</div> \
                                  <div class="group-list-filter-container"> \
                                    <input type="text" id="filterInput" {tabindex} class="input" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" placeholder="{tooltip}" title="{tooltip}" {redaonly_attr} /> \
                                    <p></p> \
                                  </div> \
                                  <div id="recordsList" class="recordlist"> \
                                    <div id="empty-with-filter" class="empty-with-filter hidden">{placeholder_message}</div> \
                                      <div class="groupsListMessageBox"> \
                                    </div> \
                                    {data} \
                                  </div> \
                              </div>';

CT.dialog.availableItem = '<div id="{id}" field="{field}" class="item recordlist-item {hint_class}" data-stataction="TreeItem" {hint_attributes}> \
                             <svg class="recordlist-item__icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#{default_icon}"></use></svg> \
                             <p class="recordlist-item__name" title="{name}">{name}</p> \
                             <svg class="recordlist-item__add-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#chooseRecord-16"></use></svg> \
                           </div>';



CT.dialog.emptyPlaceholder = '<tr><td valign="top" colspan="{cols_count}" class="dataTables_empty">{message}</td></tr>';

CT.dialog.sortingButtons =  '<p class="ArrowUp.png itemUp clickable {is_hidden} float_left" ></p>\
                            <p class="ArrowDown.png itemDown clickable {is_hidden} float_right"></p>';


CT.dialog.sortButtons = '<div id="sort_buttons" class="sort-selected-records"> \
                          <svg id="move_up" class="sort-selected-records__button sort-selected-records__button_up"> \
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#navigationLeft-16"></use> \
                          </svg> \
                          <svg id="move_down" class="sort-selected-records__button sort-selected-records__button_down"> \
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#navigationLeft-16"></use> \
                          </svg> \
                        </div>';
